import { createSlice } from "@reduxjs/toolkit";
import { createThunkFromApi } from "store/utils";
import marketApi from "./marketApi";

export const getMarketForm = createThunkFromApi(
  "convert/getMarketForm",
  marketApi.getMarketForm
);

export const getMarketLoggedInForm = createThunkFromApi(
  "convert/getMarketLoggedInForm",
  marketApi.getMarketLoggedInForm
);

export const getMarketLoggedInList = createThunkFromApi(
  "convert/getMarketLoggedInList",
  marketApi.getMarketLoggedInList
);

export const getSingleMarketLoggedInList = createThunkFromApi(
  "convert/getSingleMarketLoggedInList",
  marketApi.getSingleMarketLoggedInList
);

export const getMarketListImportantWithGOLD = createThunkFromApi(
  "convert/getMarketListImportantWithGOLD",
  marketApi.getMarketListImportantWithGOLD
);

export const markFavorite = createThunkFromApi(
  "convert/markFavorite",
  marketApi.markFavorite
);

const initialState = {
  marketForm: null,
  marketLoggedInForm: null,
  marketLoggedInList: null,
  singleMarketLoggedInList: null,
  marketListImportantWithGold: null,
};

export const marketSlice = createSlice({
  name: "market",
  initialState,

  extraReducers: {
    [getMarketForm.fulfilled]: (state, { payload }) => {
      state.marketForm = payload.data;
    },

    [getMarketLoggedInForm.fulfilled]: (state, { payload }) => {
      state.marketLoggedInForm = payload.data;
    },

    [getMarketLoggedInList.fulfilled]: (state, { payload }) => {
      state.marketLoggedInList = payload.data;
    },

    [getSingleMarketLoggedInList.fulfilled]: (state, { payload }) => {
      state.singleMarketLoggedInList = payload.data?.data?.[0] || [];
    },

    [getMarketListImportantWithGOLD.fulfilled]: (state, { payload }) => {
      state.marketListImportantWithGold = payload.data;
    },
  },
});

export default marketSlice.reducer;
